import { serverContext } from "js/config";

export function formatPrice(
    amount: number,
    currency: string
): string {
    currency = currency.toUpperCase();
    return new Intl.NumberFormat(serverContext.locale ?? "en-US", {
        style: "currency",
        currency,
    }).format(amount);
}
